<template>
  <v-container grid-list-xl>
    <v-card>
      <v-toolbar flat color="red lighten-5">
        <v-icon left color="red darken-2">assignment_return</v-icon>
        <v-toolbar-title class="font-weight-bold red--text text--darken-2">İade Edilenler</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip color="red darken-2" text-color="white" small label>Toplam {{ returnedOrders.length }} kayıt</v-chip>
      </v-toolbar>

      <v-layout wrap align-center class="px-3 pt-3">
        <v-flex xs12 sm3 class="px-2">
          <v-menu v-model="menu1" :close-on-content-click="false" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="startDate" label="Başlangıç Tarihi" prepend-icon="event" readonly v-on="on" hide-details></v-text-field>
            </template>
            <v-date-picker v-model="startDate" locale="tr-TR" @input="menu1 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm3 class="px-2">
          <v-menu v-model="menu2" :close-on-content-click="false" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="endDate" label="Bitiş Tarihi" prepend-icon="event" readonly v-on="on" hide-details></v-text-field>
            </template>
            <v-date-picker v-model="endDate" locale="tr-TR" @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm3 class="px-2">
          <v-text-field v-model="search" label="Ara (sipariş no / alıcı / ürün)" prepend-icon="search" clearable hide-details></v-text-field>
        </v-flex>
        <v-flex xs12 sm3 class="px-2">
          <v-btn color="red darken-2" dark :loading="loading" @click="load">
            <v-icon left>filter_list</v-icon>Listele
          </v-btn>
        </v-flex>
      </v-layout>

      <v-data-table :headers="headers" :items="filteredOrders" :loading="loading" :rows-per-page-items="[25, 50, 100, { text: 'Tümü', value: -1 }]" class="elevation-0 mt-2">
        <template v-slot:items="props">
          <td class="px-2">{{ formatDate(props.item.orderDate) }}</td>
          <td class="px-2">{{ firstOrderNumber(props.item) }}</td>
          <td class="px-2">{{ props.item.recipientName }}</td>
          <td class="px-2">{{ props.item.shippingCity }}</td>
          <td class="px-2">{{ productSummary(props.item) }}</td>
          <td class="px-2 text-xs-center">{{ props.item.quantity }}</td>
          <td class="px-2 text-xs-right">{{ formatMoney(props.item.totalAmount) }} ₺</td>
          <td class="px-2">
            <v-chip small :color="props.item.state === 4 ? 'red darken-1' : 'grey darken-1'" text-color="white">{{ stateLabel(props.item.state) }}</v-chip>
          </td>
          <td class="px-2">{{ formatDate(props.item.updatedDate) }}</td>
          <td class="px-2" v-if="isIdia">
            <v-chip v-if="props.item.ykIsReturned" small color="deep-orange darken-1" text-color="white" :title="props.item.ykOperationMessage || ''">
              YK İade{{ props.item.ykIsReturnedAuto ? ' (Oto)' : '' }}
            </v-chip>
            <span v-else class="grey--text">-</span>
          </td>
        </template>
        <template v-slot:no-data>
          <div class="pa-4 text-xs-center grey--text">{{ loading ? 'Yükleniyor...' : 'Seçili aralıkta iade edilen sipariş yok.' }}</div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { authenticationService } from "@/_services";

export default {
  data() {
    return {
      loading: false,
      menu1: false,
      menu2: false,
      startDate: null,
      endDate: null,
      search: '',
      tenantId: null,
      mpId: null,
      returnedOrders: [],
      stateItems: [
        { id: 0, value: 'Yeni Sipariş' },
        { id: 1, value: 'Tedarik Sürecinde' },
        { id: 2, value: 'Kargo Gönderildi' },
        { id: 3, value: 'İptal Edildi' },
        { id: 4, value: 'İade Verildi' },
        { id: 5, value: 'Havale Bekleniyor' },
        { id: 6, value: 'Teslim Edildi' },
      ],
    };
  },
  computed: {
    isIdia() {
      return Number(this.mpId) === 5;
    },
    headers() {
      const h = [
        { text: 'Tarih', value: 'orderDate', sortable: true },
        { text: 'Sipariş No', value: 'orderNumber', sortable: false },
        { text: 'Alıcı', value: 'recipientName', sortable: false },
        { text: 'Şehir', value: 'shippingCity', sortable: false },
        { text: 'Ürün', value: 'productName', sortable: false },
        { text: 'Adet', value: 'quantity', sortable: false, align: 'center' },
        { text: 'Tutar', value: 'totalAmount', sortable: false, align: 'right' },
        { text: 'Durum', value: 'state', sortable: false },
        { text: 'İade Tarihi', value: 'updatedDate', sortable: true },
      ];
      if (this.isIdia) h.push({ text: 'YK Durumu', value: 'ykIsReturned', sortable: false });
      return h;
    },
    filteredOrders() {
      const q = (this.search || '').trim().toLocaleLowerCase('tr');
      if (!q) return this.returnedOrders;
      return this.returnedOrders.filter((o) => {
        const inItems = (o.items || []).some((i) =>
          (i.orderNumber || '').toLocaleLowerCase('tr').includes(q) ||
          (i.productName || '').toLocaleLowerCase('tr').includes(q));
        return inItems || (o.recipientName || '').toLocaleLowerCase('tr').includes(q);
      });
    },
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.returnedOrders = (await this.$store.dispatch('orders/getReturnedOrders', {
          startDate: this.startDate,
          endDate: this.endDate,
        })) || [];
      } catch (e) {
        this.returnedOrders = [];
      } finally {
        this.loading = false;
      }
    },
    firstOrderNumber(order) {
      const items = order.items || [];
      if (items.length === 0) return order.packageNumber || '-';
      return items[0].orderNumber || order.packageNumber || '-';
    },
    productSummary(order) {
      const items = order.items || [];
      if (items.length === 0) return '-';
      const first = items[0].productName || '-';
      return items.length > 1 ? `${first} (+${items.length - 1})` : first;
    },
    stateLabel(state) {
      const found = this.stateItems.find((s) => s.id === Number(state));
      return found ? found.value : state;
    },
    formatDate(value) {
      if (!value) return '';
      const d = new Date(value);
      if (isNaN(d.getTime())) return value;
      return d.toLocaleDateString('tr-TR');
    },
    formatMoney(value) {
      return (Number(value) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
  async mounted() {
    const selectedTenant = localStorage.getItem('selectedTenantId');
    const selectedMp = localStorage.getItem('selectedMpId');
    const currentUser = authenticationService.currentUserValue;
    this.tenantId = selectedTenant || (currentUser && currentUser.tenantId) || localStorage.getItem('tenantId');
    this.mpId = selectedMp || (currentUser && currentUser.mpId);

    const today = new Date();
    const past = new Date();
    past.setDate(today.getDate() - 30);
    this.startDate = past.toISOString().substr(0, 10);
    this.endDate = today.toISOString().substr(0, 10);

    await this.load();
  },
};
</script>
